var _excluded = ["display", "flexDirection", "justifyContent", "alignItems", "marginBottom", "marginTop", "innerRef"];
var _templateObject;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import React, { forwardRef } from 'react';
import MuiBox from '@material-ui/core/Box';
import styled from 'styled-components';
var BREAKPOINTS = ['xs', 'sm', 'md', 'lg', 'xl'];
/**
 * Creates the media breakpoints necessary to support "responsive array
 * syntax".
 *
 * See this article:
 * https://paulie.dev/posts/2020/08/styled-components-responsive-array-syntax/
 *
 * TODO: consider moving this to utils if used in more than one spot
 */
export var getResponsiveStyles = function getResponsiveStyles(propertyName, propertyValues, theme) {
  var _theme$breakpoints;
  if (!Array.isArray(propertyValues) || !(theme !== null && theme !== void 0 && (_theme$breakpoints = theme.breakpoints) !== null && _theme$breakpoints !== void 0 && _theme$breakpoints.up)) {
    return '';
  }
  var css = '';
  var xsVal = propertyValues[0];
  var smVal = propertyValues[1];
  var mdVal = propertyValues[2];
  var lgVal = propertyValues[3];
  var xlVal = propertyValues[4];
  if (xsVal) {
    css += "".concat(propertyName, ": ").concat(xsVal, ";\n");
  }
  if (smVal) {
    css += "\n            ".concat(theme.breakpoints.up('sm'), " {\n                ").concat(propertyName, ": ").concat(smVal, ";\n            }\n        ");
  }
  if (mdVal) {
    css += "\n            ".concat(theme.breakpoints.up('md'), " {\n                ").concat(propertyName, ": ").concat(mdVal, ";\n            }\n        ");
  }
  if (lgVal) {
    css += "\n            ".concat(theme.breakpoints.up('lg'), " {\n                ").concat(propertyName, ": ").concat(lgVal, ";\n            }\n        ");
  }
  if (xlVal) {
    css += "\n            ".concat(theme.breakpoints.up('xl'), " {\n                ").concat(propertyName, ": ").concat(xlVal, ";\n            }\n        ");
  }
  return css;
};
export var getResponsiveStylesSpacing = function getResponsiveStylesSpacing(values) {
  if (!Array.isArray(values)) {
    return values !== null && values !== void 0 ? values : {};
  }
  var result = {};
  for (var i = 0; i < values.length; i++) {
    var val = values[i];
    if ((val !== null && val !== void 0 ? val : false) !== false) {
      var breakpoint = BREAKPOINTS[i];
      result[breakpoint] = val;
    }
  }
  return result;
};
var BoxStyled = styled(function (_ref) {
  var display = _ref.display,
    flexDirection = _ref.flexDirection,
    justifyContent = _ref.justifyContent,
    alignItems = _ref.alignItems,
    marginBottom = _ref.marginBottom,
    marginTop = _ref.marginTop,
    innerRef = _ref.innerRef,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MuiBox, _extends({}, otherProps, {
    alignItems: Array.isArray(alignItems) ? undefined : alignItems,
    display: Array.isArray(display) ? undefined : display,
    flexDirection: Array.isArray(flexDirection) ? undefined : flexDirection,
    justifyContent: Array.isArray(justifyContent) ? undefined : justifyContent,
    marginBottom: getResponsiveStylesSpacing(marginBottom),
    marginTop: getResponsiveStylesSpacing(marginTop)
    // @ts-expect-error: see https://github.com/mui-org/material-ui/issues/17010
    ,
    ref: innerRef
  }));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return getResponsiveStyles('display', props.display, props.theme);
}, function (props) {
  return getResponsiveStyles('flex-direction', props.flexDirection, props.theme);
}, function (props) {
  return getResponsiveStyles('justify-content', props.justifyContent, props.theme);
}, function (props) {
  return getResponsiveStyles('align-items', props.alignItems, props.theme);
});
export var Box = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(BoxStyled, _extends({}, props, {
    innerRef: ref
  }));
});
Box.displayName = 'Box';